/**
 * Ribbon menu.
 */

import React from 'react';

import './RibbonMenu.scss';

const RibbonSplit = props => {
    return <div className="ribbonSplit"></div>;
};

export default RibbonSplit;
